<template>
  <article>
    <v-list class="profile-drawer-menu" nav dense>
      <v-subheader class="profile-drawer-menu__title">
        МЕНЮ
      </v-subheader>
      <v-list-item-group>
        <v-list-item to="/profile" dense>
          Профиль
        </v-list-item>
        <!-- без права распоряжаться счётом пункты остаются кликабельными, но гаснут:
             просмотрщик и супер-админ видят страницы без действий, остальные — заглушку -->
        <v-list-item
          :to="{ name: RouteName.BillingMyTariff}"
          :class="{ 'profile-drawer-menu__item_locked': billingLocked }"
          dense
        >
          Мой тариф
        </v-list-item>
        <v-list-item
          :to="{ name: RouteName.BillingPaymentMethods}"
          :class="{ 'profile-drawer-menu__item_locked': billingLocked }"
          dense
        >
          Способы оплаты
        </v-list-item>
        <v-list-item
          :to="{ name: RouteName.BillingPaymentsHistory}"
          :class="{ 'profile-drawer-menu__item_locked': billingLocked }"
          dense
        >
          История платежей
        </v-list-item>
        <v-list-item
          :to="{ name: RouteName.BillingWriteOffs}"
          :class="{ 'profile-drawer-menu__item_locked': billingLocked }"
          dense
        >
          Списания
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </article>
</template>

<script>
  import RouteName from '@/models/enums/RouteName'

  export default {
    name: 'ProfileDrawerMenu',
    props: {
      billingLocked: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      RouteName () {
        return RouteName
      },
    },
  }
</script>

<style scoped lang="less">
::v-deep {
  .profile-drawer-menu {
    .v-list-item {
      min-height: 30px;
    }

    // тема Vuetify красит пункт своим !important той же специфичности —
    // перебиваем, добавляя в цепочку .v-list-item
    .v-list-item.profile-drawer-menu__item_locked {
      color: #999 !important;
    }
  }
}

.profile-drawer-menu {
  padding: 0;

  &__title {
    font-size: 12px;
  }
}
</style>
